// 결제 관리 페이지 관련 데이터 모델들

// 결제 내역 인터페이스
export interface Payment {
  승인날짜: string;
  결제유저명: string;
  결제상품명: string;
  결제금액: number;
  결제수단: string;
  카드사: string;
  카드번호: string;
  결제상태?: string; // 결제 상태 (승인, 취소, 환불 등)
}

// 결제 검색 파라미터 인터페이스
export interface PaymentSearchParams {
  year_month?: string;  // 연월 필터 (예: 2025-05)
  q?: string;          // 검색어 (결제상품명, 카드사, 유저명 등)
  sort_by?: string;    // 정렬 대상 필드 (기본값: create_datetime)
  order?: 'asc' | 'desc'; // 정렬 순서 (기본값: desc)
  page?: number;       // 페이지 번호 (기본값: 1)
  limit?: number;      // 항목 개수 (기본값: 15)
}

// 결제 목록 응답 인터페이스
export interface PaymentListResponse {
  payments: Payment[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

// 결제 통계 인터페이스
export interface PaymentStats {
  월결제금액: number;
  월결제건수: number;
  월결제고객수: number;
  증감금액: number;
  증감건수: number;
  증감고객수: number;
}

// 페이지 크기 옵션
export const PAYMENT_LIMIT_OPTIONS = [15, 30, 50, 100];

// 정렬 옵션
export const PAYMENT_SORT_OPTIONS = [
  { value: 'create_datetime', label: '승인날짜' },
  { value: '결제금액', label: '결제금액' },
  { value: '결제유저명', label: '유저명' },
  { value: '결제상품명', label: '상품명' }
];

// 정렬 순서 옵션
export const PAYMENT_ORDER_OPTIONS = [
  { value: 'desc', label: '내림차순' },
  { value: 'asc', label: '오름차순' }
]; 